import { createSlice } from "@reduxjs/toolkit";
import { SUPER_REGIONS } from "../../util/constants";

// Initial state with default region
const initialState = {
  selectedRegion: null, // Default to "General"
};

const regionSlice = createSlice({
  name: "region",
  initialState,
  reducers: {
    setSelectedRegion: (state, action) => {
      state.selectedRegion = action.payload;
    },
    resetRegion: (state) => {
      state.selectedRegion = null;
    },
  },
});

export const { setSelectedRegion, resetRegion } = regionSlice.actions;

// Selector to get selected region
export const selectSelectedRegion = (state) => state.region.selectedRegion;

export default regionSlice.reducer;
